import { Components, Theme } from '@mui/material/styles';

export const paperTheme: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    rounded: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
    }),
  },
};
